/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { isEmpty } from "lodash";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { useFeatureFlag } from "cms/features/use-feature-flag";

const HeadingComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const value = component?.value;
    const style = component?.style;
    const color = component?.color;
    const hasContent = !isEmpty(value);
    const isHeading1 = style === "heading1";
    const isHeading2 = style === "heading2";
    const isHeading3 = style === "heading3";
    const isHeading4 = style === "heading4";
    const displayClass = `simplicity-heading ${style}`;
    const colorFeatureEnabled = useFeatureFlag("feature_rich_text_colour");
    const headingStyle = colorFeatureEnabled ? { color } : {};

    return (
        <div className="tiptap preview">
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
            {hasContent && isHeading1 &&
                <h1 className={displayClass} style={headingStyle}>{value}</h1>
            }
            {hasContent && isHeading2 &&
                <h2 className={displayClass} style={headingStyle}>{value}</h2>
            }
            {hasContent && isHeading3 &&
                <h3 className={displayClass} style={headingStyle}>{value}</h3>
            }
            {hasContent && isHeading4 &&
                <h4 className={displayClass} style={headingStyle}>{value}</h4>
            }
        </div>
    );
};
HeadingComponentDisplay.displayName = "HeadingComponentDisplay";
export { HeadingComponentDisplay };
